let seqid = 100

export const getSeqId = () => {
  return seqid++
}

/**
 * 获取链接参数
 */
export const getParameter = (name) => {
  try {
    let result = location.search.match(
      new RegExp('[\\?\\&]' + name + '=([^\\&]+)', 'i')
    );
    if (result && result.length && result.length > 1) {
      return decodeURIComponent(result[1].replace(/\+/g, ' '));
    }
  } catch (e) {
    return '';
  }
  return '';
};
export function uuid(len, radix) {
  var chars =
    '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
  var uuid = [],
    i;
  radix = radix || chars.length;
  if (len) {
    // Compact form
    for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
  } else {
    // rfc4122, version 4 form
    var r;
    // rfc4122 requires these characters
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
    uuid[14] = '4';
    // Fill in random data.  At i==19 set the high bits of clock sequence as
    // per rfc4122, sec. 4.1.5
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | (Math.random() * 16);
        uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r];
      }
    }
  }
  return uuid.join('');
}

/**
 * 时间戳转日期
 * @param {*} timestamp
 * @returns
 */
export const getTimeStampDate = (timestamp) => {
  let now = new Date(timestamp);
  let y = now.getFullYear();
  let m = now.getMonth() + 1;
  let d = now.getDate();
  return (
    y +
    '-' +
    (m < 10 ? '0' + m : m) +
    '-' +
    (d < 10 ? '0' + d : d) +
    ' ' +
    now.toTimeString().substr(0, 5)
  );
};
/**
 * 获取文件名
 * @param {*} name
 * @returns
 */
export const getFileName = (name) => {
  // console.log(name.split('.').pop(), "name");
  return name.substr(0, name.lastIndexOf('.'));
};
/**
 * 获取后缀名
 * @param {*} name
 * @returns
 */
export const getExtension = (name) => {
  return name.substr(name.lastIndexOf('.'));
};

/**
 * @function dateFormat
 * @desc 将 Date 转化为指定格式的String
 * 月(M)、日(D)、小时(H)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
 * 年(Y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
 * 例子：
 * dateFormat(new Date(), "YYYY-MM-DD HH:mm:ss.S") ==> 2006-07-02 08:09:04.423
 * dateFormat(new Date(), "YYYY-M-D H:m:s.S")      ==> 2006-7-2 8:9:4.18
 * @param {Date} date new Date()
 * @param {string} fmt "HH:ss"
 * @returns {string}
 */
export function dateFormat(date, fmt) {
  var o = {
    'M+': date.getMonth() + 1, //月份
    'D+': date.getDate(), //日
    'H+': date.getHours(), //小时
    'm+': date.getMinutes(), //分
    's+': date.getSeconds(), //秒
    'q+': Math.floor((date.getMonth() + 3) / 3), //季度
    S: date.getMilliseconds(), //毫秒
  };
  if (/(Y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + '').substr(4 - RegExp.$1.length)
    );
  for (var k in o)
    if (new RegExp('(' + k + ')').test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      );
  return fmt;
}

/**
 * s2hms
 * @param {number} time 秒
 * @returns {string} 时:分:秒
 */
export function s2hms(time) {
  if (!time) return "00:00:00";
  let result = parseInt(time);
  const h = `${result / 3600 >> 0}`.padStart(2, "0");
  const m = `${(result / 60) % 60 >> 0}`.padStart(2, "0");
  const s = `${result % 60 >> 0}`.padStart(2, "0");
  return `${h}:${m}:${s}`;
}

export function downSortcompare(property) {
  return function (a, b) {
    var value1 = a[property];
    var value2 = b[property];
    return value2 - value1;
  };
}

export function upSortcompare(property) {
  return function (a, b) {
    var value1 = a[property];
    var value2 = b[property];
    return value1 - value2;
  };
}

export function addStreamStopListener(stream, callback) {
  var streamEndedEvent = 'ended';
  if (stream) {
    if ('oninactive' in stream) {
      streamEndedEvent = 'inactive';
    }
    stream.addEventListener(streamEndedEvent, function () {
      callback();
      callback = function () { };
    }, false);
    stream.getAudioTracks().forEach(function (track) {
      track.addEventListener(streamEndedEvent, function () {
        callback();
        callback = function () { };
      }, false);
    });
    stream.getVideoTracks().forEach(function (track) {
      track.addEventListener(streamEndedEvent, function () {
        callback();
        callback = function () { };
      }, false);
    });
  }
}

/**
 * @function getCursorIndex
 * @desc 获取光标位置
 * @param {HTMLInputElement} element input/textarea
 * @returns {number}
 */
export function getCursorIndex(element) {
  let cursorPos = 0;
  if (document.selection) {
    var selectRange = document.selection.createRange();
    selectRange.moveStart("character", -element.value.length);
    cursorPos = selectRange.text.length;
  } else if (element.selectionStart || element.selectionStart == "0") {
    cursorPos = element.selectionStart;
  }
  return cursorPos;
}


export function deepClone(obj) {
  // 判断要进行深拷贝的是数组还是对象
  var objClone = Array.isArray(obj) ? [] : {};

  // 进行深拷贝的数值不能为空，并且是对象或者是数组
  if (obj && typeof obj === 'object') {
    for (let key in obj) {
      // 判断自身是否有这个属性
      // eslint-disable-next-line no-prototype-builtins
      if (obj.hasOwnProperty(key)) {
        // 判断属性是否为引用类型
        if (obj[key] && typeof obj[key] === 'object') {
          objClone[key] = deepClone(obj[key]);
        } else {
          objClone[key] = obj[key];
        }
      }
    }
  }

  return objClone;
}

export function device() {
  const ua = navigator.userAgent.toLowerCase()
  return {
    isIE: ua.includes('trident'),
    isFireFox: ua.includes('firefox'),
    isSafari: ua.match(/Version\/([\d.]+).*safari/),
    isChrome : /chrome/.test(ua),
  }
}

export function environment() {
  const ua = navigator.userAgent.toLowerCase()
  const isAndroid = ua.indexOf('android') > -1 || ua.indexOf('adr') > -1; //android终端
  const isIOS = ua.indexOf('iphone') > -1; //ios终端
  const isMac = ua.indexOf('macintosh') > -1; //mac端
  const isWindows = ua.indexOf('windows') > -1;
  return {
    ios: isIOS,
    android: isAndroid,
    mac: isMac,
    win: isWindows
  }
}

export function getFFVer() {
  var ua = navigator.userAgent;
  var b = ua.indexOf("Firefox/");
  if (b < 0) {
    return 0;
  }
  return parseFloat(ua.substring(b + 8, ua.lastIndexOf(".")));
}
// export function getChromeVersion() {
//   var arr = navigator.userAgent.split(' ');
//   var chromeVersion = '';
//   for (var i = 0; i < arr.length; i++) {
//     if (/chrome/i.test(arr[i]))
//       chromeVersion = arr[i]
//   }
//   if (chromeVersion) {
//     return Number(chromeVersion.split('/')[1].split('.')[0]);
//   } else {
//     return false;
//   }
// }

export const getChromeVersion = () => {
  const userAgent = navigator.userAgent;
  const chromeMatch = userAgent.match(/Chrome\/(\d+)/);
  return chromeMatch ? parseInt(chromeMatch[1]) : false;
};

/**
 * download bolb file
 * @param {*} content
 * @param {*} type
 * @param {*} fileName
 */
export const downloadBlob = (content, type, fileName) => {
  const blob = new Blob([content], { type: type });
  let downloadElement = document.createElement("a");  // 创建下载的链接
  let href = window.URL.createObjectURL(blob);
  downloadElement.href = href;  // 下载后文件名
  downloadElement.download = fileName;  //this.$t("message.白名单")
  document.body.appendChild(downloadElement);  // 点击下载
  downloadElement.click();  // 下载完成移除元素
  document.body.removeChild(downloadElement);  // 释放掉blob对象
  window.URL.revokeObjectURL(href);
};

export const chooseLanguage = ()=>{
  let lang = "zh-CN";
  // let chooseLang = sessionStorage.getItem("lang")
  // if(chooseLang){
  //   lang = chooseLang;
  // }else{
    const browserLanguage = window.navigator.language;
    if(browserLanguage === 'zh-CN' || browserLanguage === 'zh-TW' || browserLanguage === 'en-US'){
      lang = browserLanguage;
    }else{
      lang= 'en-US';
    }
    lang = browserLanguage;
  // }
  console.log(lang);
  return lang;
}

export const fullScreen = (ele)=>{
  if (ele.requestFullscreen) {
    ele.requestFullscreen();
  } else if (ele.mozRequestFullScreen) {
    ele.mozRequestFullScreen();
  } else if (ele.webkitRequestFullscreen) {
    ele.webkitRequestFullscreen();
  } else if (ele.msRequestFullscreen) {
    ele.msRequestFullscreen();
  }
}

export const exitFullscreen = ()=> {
  if(document.exitFullScreen) {
    document.exitFullScreen();
  } else if(document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if(document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  } else if(document.msExitFullscreen) {
    document.msExitFullscreen();
  }
}

export const macVersion = ()=>{
  var ua = navigator.userAgent.toLowerCase();
    var version = null;
    var reg = /x [\d._]+/gi;
    var v_info = ua.match(reg);
    version = (v_info + "").replace(/[^0-9|_.]/ig, "").replace(/_/ig, "."); //得到版本号9.3.2或者9.0
    //version = parseInt(version.split('.')[0]); // 得到版本号第一位
   console.log(parseInt(version.split('.')[0]),"mac version");
    return parseInt(version.split('.')[0]);
}

export const sysInfo= () => {
  function isSafari() {
    return /^((?!chrome|android).)*safari/i.test(window.navigator.userAgent);
  }
  var info = Object.create({});
  // Runtime info.
  var userAgent = navigator.userAgent;
  var firefoxRegex = /Firefox\/([0-9\.]+)/;
  var chromeRegex = /Chrome\/([0-9\.]+)/;
  var edgeRegex = /Edge\/([0-9\.]+)/;
  var safariVersionRegex = /Version\/([0-9\.]+) Safari/;
  var result = chromeRegex.exec(userAgent);
  if (result) {
    info.runtime = {
      name: "Chrome",
      version: result[1].split(".")[0]
    };
  } else if ((result = firefoxRegex.exec(userAgent))) {
    info.runtime = {
      name: "Firefox",
      version: result[1]
    };
  } else if ((result = edgeRegex.exec(userAgent))) {
    info.runtime = {
      name: "Edge",
      version: result[1]
    };
  } else if (isSafari()) {
    result = safariVersionRegex.exec(userAgent);
    info.runtime = {
      name: "Safari"
    };
    info.runtime.version = result ? result[1] : "Unknown";
  } else {
    info.runtime = {
      name: "Unknown",
      version: "Unknown"
    };
  }
  // OS info.
  var windowsRegex = /Windows NT ([0-9\.]+)/;
  var macRegex = /Intel Mac OS X ([0-9_\.]+)/;
  var iPhoneRegex = /iPhone OS ([0-9_\.]+)/;
  var linuxRegex = /X11; Linux/;
  var androidRegex = /Android( ([0-9\.]+))?/;
  var chromiumOsRegex = /CrOS/;
  if ((result = windowsRegex.exec(userAgent))) {
    info.os = {
      name: "windows",
      version: result[1]
    };
  } else if ((result = macRegex.exec(userAgent))) {
    info.os = {
      name: "mac",
      version: result[1].replace(/_/g, ".")
    };
  } else if ((result = iPhoneRegex.exec(userAgent))) {
    info.os = {
      name: "iPhone OS",
      version: result[1].replace(/_/g, ".")
    };
  } else if ((result = linuxRegex.exec(userAgent))) {
    info.os = {
      name: "Linux",
      version: "Unknown"
    };
  } else if ((result = androidRegex.exec(userAgent))) {
    info.os = {
      name: "Android",
      version: result[1] || "Unknown"
    };
  } else if ((result = chromiumOsRegex.exec(userAgent))) {
    info.os = {
      name: "Chrome OS",
      version: "Unknown"
    };
  } else {
    info.os = {
      name: "Unknown",
      version: "Unknown"
    };
  }
  info.capabilities = {
    continualIceGathering: false,
    unifiedPlan: false,
    streamRemovable: info.runtime.name !== "Firefox"
  };
  return info;
}